import { createAction } from '@reduxjs/toolkit';

export const setRedirectUrl = createAction('setRedirectUrl');
